import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type BreakingNewsStoriesProps = {
  /** The list of the articles */
  cardProps: ComponentProps<typeof Card>;
  /** Index of the article in the list */
  index: number;
};

/**
 * Renders a single story card for the Breaking News section.
 */
const BreakingNewsStories = ({
  cardProps,
  index,
}: BreakingNewsStoriesProps): React.ReactElement => {
  const variant: CardVariations = {
    kicker: {
      color: "text-gray-515",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "my-1",
    },
    content: {
      width: "w-full",
      extraClass: "h-full",
      updatedTimeColor: "text-red",
      updatedTimeWrapperClass: "mt-auto",
    },
  };

  return (
    <div
      className={cn("story border-b border-gray-175 py-3 lg:col-span-1", {
        "lg:order-1": index < 2,
        "lg:order-3": index >= 2,
        "lg:mr-3": index === 1 || index === 3,
        "lg:border-none": index === 6 || index === 7,
        "border-none lg:border-b": index === 7,
      })}
      data-testid="homepage-breaking-news-stories-individual-component"
    >
      <Card
        {...cardProps}
        variations={variant}
        className={cn("h-full border-gray-175", {
          "lg:border-r lg:pr-3": [0, 2, 4, 6].includes(index),
          "lg:pl-3": [1, 3, 5, 7].includes(index),
          "lg:pr-3": [1, 3].includes(index),
        })}
      />
    </div>
  );
};

export default BreakingNewsStories;
